import { reatomAsync, withAbort, withDataAtom } from "@reatom/async";
import { atom } from "@reatom/framework";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";
import { isAdmin } from "src/util";

export const getMeRequest = reatomAsync(async (ctx) => {
  return API.userApi
    .userControllerGetMe({ signal: ctx.controller.signal })
    .then((d) => d.data);
}, "getMeRequest").pipe(withDataAtom(null), withAbort(), withIsLoadingAtom());

export const getAccessRightsMapAtom = atom((ctx) => {
  const rights = ctx.spy(getMeRequest.dataAtom)?.rights || [];
  return new Map(rights.map((right) => [right.key, new Date(right.expiredAt)]));
}, "getAccessRightsMapAtom");

export const isAdminAtom = atom(
  (ctx) => isAdmin(ctx.spy(getMeRequest.dataAtom)),
  "isAdminAtom",
);
